let EDIT_CUSTOMER_TAB = {
  options: {
    searchLabel: 'customer name or id',
    dataSet: 'customers',
  }
};


export
default EDIT_CUSTOMER_TAB;


// WEBPACK FOOTER //
// ./app/models/editCustomerTab.js